import { config } from "@libs/config/config";

export const stripeAccountBaseUrl = () => {
  return config.env === "prod"
    ? "https://dashboard.stripe.com/"
    : "https://dashboard.stripe.com/test/";
};
